<div class="dialog-content-wrapper feedback-dialog" style="padding: 0">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span id="dlgCategoryTitle" class="title dialog-title">Feedback</span>
      <button id="dlgCategoryClose" mat-icon-button class="mat-icon-button white-fg" (click)="dialogRef.close()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
    <form class="addDialog" [formGroup]="form" fxLayout="column" fxFlex>
      <mat-form-field color="accent">        
        <mat-label>Feedback</mat-label>
        <textarea [(ngModel)]="feedback" name="feedback" matInput class="form-control" formControlName="feedback" required rows="20" [setFocus]="true"></textarea>
        <mat-error style="margin-left: -16px" *ngIf="this.form.get('feedback').hasError('required')">
            Required.
        </mat-error>
        <mat-error style="margin-left: -16px" *ngIf="this.form.get('feedback').hasError('maxlength')">
            Max length is 500 characters
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <button id="btnSendFeedback" mat-raised-button type="submit" [disabled]="(!form.valid) || (form.pristine)"
        (click)="sendFeedback()" class="save-button mat-accent" aria-label="SEND" matTooltip="Send feedback">
        SEND FEEDBACK
      </button>
    </div>
  </div>
</div>
